import script from "./StatusSyncPortais.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusSyncPortais.vue?vue&type=script&setup=true&lang=js"

import "./StatusSyncPortais.vue?vue&type=style&index=0&id=62057d4a&scoped=true&lang=css"

import exportComponent from "D:\\Web\\LanceFacilUserNEW\\ClientAPPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62057d4a"]])

export default __exports__